// 环境配置文件

// 获取当前环境
const getEnv = (): string => {
  return process.env.REACT_APP_ENV || 'dev';
};

// 上传接口域名（所有环境统一使用）
const iotLocalUrl = 'http://iot-local.jetinno.com';
const iotTestUrl = 'https://iot-test.jetinno.com';
const prodUploadUrl = 'https://iot.jetinno.com';

// 接口域名配置
const apiDomains = {
  dev: {
    baseURL: 'http://10.64.41.215:8019', // 开发环境使用相对路径，通过本地代理转发
    uploadURL: iotLocalUrl,
  },
  test: {
    baseURL: 'https://home-saas-test.jetinno.com/', // 测试环境使用相对路径，通过本地代理转发
    uploadURL: iotTestUrl,
  },
  pre: {
    baseURL: 'https://home-saas-test.jetinno.com/', // 预发布环境使用相对路径，通过本地代理转发
    uploadURL: prodUploadUrl,
  },
  prod: {
    baseURL: 'https://home-saas.jetinno.com/', // 'https://new-saas.jetinno.com/api', // 生产环境
    uploadURL: prodUploadUrl,
  },
};

// 当前环境的配置
const currentEnv = getEnv();
const currentConfig = apiDomains[currentEnv as keyof typeof apiDomains] || apiDomains.dev;

export const API_CONFIG = {
  ...currentConfig,
  env: currentEnv,
  // 控制是否加密
  encrypt: false, // 默认不加密
  // 控制上传是否加密
  uploadEncrypt: true, // 默认加密
};

export default API_CONFIG;
